import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, withAllColumnsWidth, withColumnsWithValuesWidth } from '../../utils';
import { getFilteredHeaders } from './headers';
import { getPreparedData } from './mappings';
import { getColumnsWidths } from './styles';
import { ExportExcelOverview } from './interfaces';

export class OverviewTemplate implements ExcelTemplate {
  export(exportExcelOverview: ExportExcelOverview): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(exportExcelOverview);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  /**
   * Here I'm using array of arrays, because I need prepare cells properly with
   * format, styles, etc.
   */
  private getSheet(exportExcelOverview: ExportExcelOverview): XLSX.WorkSheet {
    const headers = getFilteredHeaders();
    const preparedData = getPreparedData(exportExcelOverview, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    return withColumnsWithValuesWidth(withAllColumnsWidth(withHeaderStyling(sheet)),
      getColumnsWidths());
  }
}
